import * as yup from "yup";
import errorMessages from "protocol-setup/constants/errorMessages";

const { infoForm } = errorMessages.openRave;

const formSchema = yup.object().shape({
  requestDate: yup.string().required(),
  lpo: yup.string().required(),
  protocolNumber: yup.string().required(),
  protocolTitle: yup.string().required(),
  requestType: yup
    .string()
    .min(1, infoForm.requestType.min)
    .required(infoForm.requestType.required),
  listOfChanges: yup
    .array(yup.string())
    .min(1, infoForm.listOfChanges.min)
    .required(infoForm.listOfChanges.required),
  describeOtherChanges: yup
    .string()
    .max(500, infoForm.describeOtherChanges.max)
    .when("listOfChanges", ([listOfChanges], schema) => {
      return listOfChanges && listOfChanges.includes("otherChanges")
        ? schema.required(infoForm.describeOtherChanges.required)
        : schema.optional();
    }),
  revisionEligibilityCriteria: yup
    .string()
    .max(500, infoForm.revisionEligibilityCriteria.max)
    .optional(),
  protocolType: yup
    .string()
    .min(1, infoForm.protocolType.min)
    .required(infoForm.protocolType.required),
  indType: yup
    .string()
    .min(1, infoForm.indType.min)
    .required(infoForm.indType.required),
  indAgent: yup
    .string()
    .max(100, infoForm.indAgent.max)
    .when("indType", ([indType], schema) => {
      return indType === "Non-CTEP held IND"
        ? schema.required(infoForm.indAgent.required)
        : schema.optional();
    }),
  indHolder: yup
    .string()
    .max(100, infoForm.indHolder.max)
    .when("indType", ([indType], schema) => {
      return indType === "Non-CTEP held IND"
        ? schema.required(infoForm.indHolder.required)
        : schema.optional();
    }),
  indNumber: yup
    .string()
    .max(100, infoForm.indNumber.max)
    .when("indType", ([indType], schema) => {
      return indType === "Non-CTEP held IND"
        ? schema.required(infoForm.indNumber.required)
        : schema.optional();
    }),
  tentativeActivationDate: yup
    .string()
    .min(1, infoForm.tentativeActivationDate.min)
    .required(infoForm.tentativeActivationDate.required),
  oewgDate: yup.string().nullable(),
  openContact: yup
    .array(yup.number())
    .min(1, infoForm.openContact.min)
    .required(infoForm.openContact.required),
  raveContact: yup
    .array(yup.number())
    .min(1, infoForm.raveContact.min)
    .required(infoForm.raveContact.required),
  otherEmailContacts: yup
    .string()
    .optional()
    .test(
      "is-valid-email-list",
      infoForm.otherEmailContacts.test,
      value => {
        if (!value || value.trim() === '') return true; // Optional field

        const emails = value.split(',').map(email => email.trim());
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        return emails.every(email => {
          if (email === '') return false; // No empty emails
          return emailRegex.test(email);
        });
      }
    )
});

export default formSchema;
